module.exports = __webpack_public_path__ + "img/lightning.60d8a619.svg";